import { Divider as CDivider, Flex, Text } from '@chakra-ui/react'
import type { ReactNode, FC } from 'react'

type Props = { children: ReactNode }

const HeaderDivider: FC<Props> = ({ children }) => {
  return (
    <Flex py="5" alignItems="center" width="100%">
      <CDivider borderColor="greys.200" />
      <Text px="4" whiteSpace="nowrap" fontSize="xl">
        {children}
      </Text>
      <CDivider borderColor="greys.200" />
    </Flex>
  )
}

export default HeaderDivider
